import Text from '~components/Text';
import { formattedMoney, millionFormattedtoString } from '~utils/formatted/number';

import * as S from './style';

interface Props {
  label: string;
  salary?: number;
}

export default function Summary({ label, salary }: Props) {
  return (
    <S.Wrapper>
      <Text typography='bold120_B3'>{label}</Text>
      <S.Salary>{salary ? `${formattedMoney(salary)}만원` : '정보없음'}</S.Salary>
    </S.Wrapper>
  );
}
